<template>
    <div style="overflow-y: scroll; height: calc(100vh - 200px)">
        <div class="df df-center">
            <a-space>
                <a-select v-model:value="requestPayload.year" :options="yearOption" placeholder="请选择年度"
                    @change="getData" allowClear style="width: 120px">
                </a-select>

                <a-select v-model:value="requestPayload.model" :options="swanMachineOptions" placeholder="请选择设备型号"
                    @change="getData" allowClear style="width: 150px">
                </a-select>
            </a-space>
        </div>
        <div class="statistics-scroll">
            <template v-for="(item, index) in statisticsData">
                <statistics :rectificationInformation="item" :columns="columns"></statistics>
            </template>
        </div>

        <failure-rate ref="failureRef"></failure-rate>
    </div>
</template>

<script>
import { defineComponent, reactive, ref, onMounted } from 'vue';
import {
    getQualityInspectionProblemSummary,
} from '@/request/view/dailyQualityInspection.js';
import statistics from '@/views/afterSaleRepair/pc/statistics.vue';
import failureRate from '@/views/productDaily/problem/failureRate.vue';
import { yearOption } from '@/views/productDaily/serve/option';
import { swanMachineOptions } from '@/components/cascader/option';
import { useRoute } from 'vue-router';


export default defineComponent({
    components: {
        statistics,
        failureRate,
    },
    setup() {
        const failureRef = ref();

        const route = useRoute();
        const statisticsData = reactive([]);

        const requestPayload = reactive({
            year: new Date().getFullYear(),
            model: null,
            produceOrTpc: route.meta.produceOrTpc
        });

        const getStatisticsList = () => {
            const data = [];
            const array = ['物料导致', '结构导致', '电子导致', '光学导致', '软件导致', '装配导致', '工艺导致', '其它问题', '合计'];
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                data.push({ problemType: element, total: 0, 现场处理: 0, 分析中: 0, 进行中: 0, 已完成: 0, });
            }
            return data;
        };

        const setStatisticsList = (data) => {
            if (!data) return [];
            const dataList = getStatisticsList();
            const totalIndex = dataList.findIndex((f) => f.problemType === '合计')
            Object.keys(data).forEach((type) => {
                // 类型
                const itemIndex = dataList.findIndex((f) => f.problemType === type);
                if (itemIndex === -1) return;
                // 整改信息
                const rectificationInformation = data[type];
                Object.keys(rectificationInformation).forEach((v) => {
                    if (dataList[itemIndex][v] === undefined) return;
                    dataList[itemIndex][v] += rectificationInformation[v];
                    dataList[totalIndex][v] += rectificationInformation[v];
                    dataList[itemIndex].total += rectificationInformation[v];
                    dataList[totalIndex].total += rectificationInformation[v];
                });
            });
            return dataList;
        };

        const getData = () => {
            failureRef.value.init(requestPayload);
            if (!requestPayload.year) return;
            statisticsData.length = 0;
            getQualityInspectionProblemSummary(requestPayload).then((res) => {
                const data = {};
                if (requestPayload.model == null) {
                    data['全部'] = res.data;
                } else {
                    data[requestPayload.model] = res.data;
                }
                if (res.code === 200 && res.message === '成功' && Object.keys(data).length > 0) {
                    Object.keys(data).forEach((key) => {
                        const item = swanMachineOptions.find((f) => f.value === key);
                        const title = item ? `${requestPayload.year}年质检问题汇总（${item.label}）系列` : `${requestPayload.year}年质检问题汇总`;
                        const statisticsDataItem = setStatisticsList(data[key]);
                        statisticsData.push({
                            title,
                            data: statisticsDataItem,
                        });
                    })
                }
            });
        }

        const columns = [
            {
                title: '问题类型',
                dataIndex: 'problemType',
                align: "center",
            },
            {
                title: '发生频率',
                dataIndex: 'total',
                align: "center",
            },
            {
                title: '整改信息',
                align: "center",
                children: [
                    {
                        title: '现场处理',
                        dataIndex: '现场处理',
                        align: "center",
                    },
                    {
                        title: '分析中',
                        dataIndex: '分析中',
                        align: "center",
                    },
                    {
                        title: '进行中',
                        dataIndex: '进行中',
                        align: "center",
                    },
                    {
                        title: '已完成',
                        dataIndex: '已完成',
                        align: "center",
                    },
                ]
            },
        ]

        onMounted(() => {
            getData();
        });

        return {
            failureRef,
            requestPayload,
            statisticsData,
            yearOption,
            getData,
            columns,
            swanMachineOptions,
        };
    }
});
</script>

<style lang="less" scoped>
.statistics-scroll {
    margin-top: 10px;
}
</style>
